import { z } from 'zod';

/**
 * ApplicationUser - Utente applicazione
 * Corrisponde al modello backend ApplicationUser (flatten da IdentityUser)
 */
export interface ApplicationUser {
	/** ID utente (GUID string) */
	id: string;
	/** Nome utente */
	userName?: string;
	/** Email */
	email?: string;
	/** Nome display (max 100 caratteri) */
	displayName?: string;
	/** Numero di telefono */
	phoneNumber?: string;
	/** Se l'utente è attivo */
	active: boolean;
	/** Ruoli utente (navigation property flattened) */
	roles?: string[];
}

/**
 * ProfileModel - Modello per il profilo utente
 * Corrisponde al modello backend ProfileModel
 */
export interface ProfileModel {
	/** Nome (required, non vuoto) */
	name: string;
	/** Codice (required, non vuoto) */
	code: string;
	/** Codice fiscale (required, non vuoto) */
	socialSecurityNumber: string;
	/** Genere (enum numerico) */
	gender: number;
	/** Data di nascita */
	birthDate?: string | null;
	/** URL immagine avatar */
	avatarImage?: string | null;
}

/**
 * Tipo per il risultato dell'autocomplete Users
 * Corrisponde ai campi selezionati nella query OData: id, userName, email, displayName, active
 */
export type ApplicationUserAutocompleteResult = Pick<
	ApplicationUser,
	'id' | 'userName' | 'email' | 'displayName' | 'active'
>;

/**
 * Schema Zod per la validazione runtime di ApplicationUser
 */
export const ApplicationUserSchema = z.object({
	id: z.string().min(1),
	userName: z.string().nullish(),
	email: z.string().email().nullish(),
	displayName: z.string().max(100).nullish(),
	phoneNumber: z.string().nullish(),
	active: z.boolean(),
	roles: z.array(z.string()).optional(),
});

/**
 * Schema Zod per la validazione runtime di ProfileModel
 */
export const ProfileModelSchema = z.object({
	name: z.string().min(1), // Required, AllowEmptyStrings = false
	code: z.string().min(1), // Required, AllowEmptyStrings = false
	socialSecurityNumber: z.string().min(1), // Required, AllowEmptyStrings = false
	gender: z.number().int(),
	birthDate: z.string().nullish(), // DateTime nullable
	avatarImage: z.string().nullish(),
});
